import { formatMoney } from './novicell_shopify-utility.js';
import { populateUpsellDrawer, openUpsellDrawer } from './novicell_upsell-shared.js';

(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const productId = window.productId;
    const handle = window.productHandle;
    const moneyFormat = window.shopMoneyFormat;
    const shopCurrency = window.shopCurrency;
    const upsellContainer = document.getElementById("upsell-container");

    // Function to display the upsell product details on the page.
    function displayUpsellProduct(product) {
      window.upsellProduct = product;

      //UPSELL DRAWER START

      //UPSELL DRAWER GALLERY
      const imagesHtml = product.images.map(image => {
        let option1 = "";
        let option2 = "";
        let option3 = "";

        for (const variant of product.variants) {
          if (variant.featured_image != null) {
            variant.featured_image.src = variant.featured_image.src.replace(/^https:/, '');
          }

          if (variant.featured_image != null && variant.featured_image.src === image) {
            option1 = variant.option1 || "";
            option2 = variant.option2 || "";
            option3 = variant.option3 || "";
            break;
          }
        }

        return `<img src="${image}&width=308" option1="${option1}" option2="${option2}" option3="${option3}" alt="${product.title || ''}">`;
      }).join("");

      const container = document.querySelector('.upsell-gallery-body');
      if (container) {
        container.innerHTML = imagesHtml;
      }

      //UPSELL DRAWER TITLE
      const primaryTitleElem = document.querySelector('.upsell-primary-title');
      const secondaryTitleElem = document.querySelector('.upsell-secondary-title');

      if (product.title) {
        const escapedTitle = product.title
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");

        const parts = escapedTitle.split(',');
        const primary = parts[0].trim();
        const secondary = parts.length > 1 ? parts.slice(1).join(',').trim() : "";

        if (primaryTitleElem) primaryTitleElem.textContent = primary;
        if (secondaryTitleElem) secondaryTitleElem.textContent = secondary;
      }

      //UPSELL DRAWER PRICES
      const priceLoweredElem = document.querySelector('.upsell-drawer-price-lowered');
      const priceRegularElem = document.querySelector('.upsell-drawer-price-regular');

      if (priceLoweredElem) {
        priceLoweredElem.textContent = formatMoney(product.price, moneyFormat).replace(/,/g, '.');
      }

      if (priceRegularElem) {
        priceRegularElem.textContent = '';
      }

      //UPSELL DRAWER VENDOR
      const vendorSpan = document.querySelector('.upsell-drawer-designer span.upsell-drawer-designer-span');
      if (vendorSpan) {
        vendorSpan.textContent = product.vendor || '';
      }

      const optionsWrapper = document.querySelector('.upsell-drawer-material-selects');
      if (optionsWrapper && product.options) {
        optionsWrapper.innerHTML = '';

        // Create template in JS (not in HTML)
        const template = document.createElement('template');
        template.innerHTML = `
        <div class="upsell-drawer-material-selects-switch tw-font-secondary tw-mr-16">
          <p class="tw-mb-3">
            <span class="option-name"></span>:<span class="seleceted-option-value tw-font-normal tw-font-primary tw-leading-normal"></span>
          </p>
          <div class="upsell-drawer-material-selects-options tw-flex tw-flex-wrap"></div>
        </div>
        `;

        product.options.forEach(option => {
          // Clone template content
          const switchDiv = template.content.cloneNode(true);

          // Set option name
          switchDiv.querySelector('.option-name').textContent = option.name;

          // Find options container inside the clone
          const optionsContainer = switchDiv.querySelector('.upsell-drawer-material-selects-options');

          option.values.forEach((value) => {
            const basePath = "/cdn/shop/files/";

            const valueNormalized = value.normalize("NFD")
              .toLowerCase()
              .replace(/\s*\|\s*/g, '-')
              .replace(/\s+/g, '-')
              .replace(/[^a-z0-9\-]/g, '');

            const filename1Base = valueNormalized;
            const filename2Base = value.normalize("NFD")
              .replace(/\s+/g, '-')
              .replace(/[^a-z0-9\-]/gi, '');

            const formats = ['jpg', 'jpeg', 'png', 'webp', 'gif'];

            const img = document.createElement('img');
            img.className = 'tw-object-fill tw-cursor-pointer tw-border-0 tw-border-transparent tw-p-0 tw-transition-colors tw-duration-200 tw-ease-in-out tw-mr-3 tw-mb-3';
            img.alt = value;
            img.setAttribute('data-option-value-name', value);

            async function checkImageExists(url) {
              return new Promise((resolve) => {
                const tester = new Image();
                tester.onload = () => resolve(true);
                tester.onerror = () => resolve(false);
                tester.src = url;
              });
            }

            function replaceImgWithLabel() {
              const label = document.createElement('label');
              label.textContent = value;
              label.setAttribute('data-option-value-name', value);
              label.setAttribute('class', 'tw-mr-3 tw-mb-3 tw-text-sm tw-text-center tw-cursor-pointer');
              img.replaceWith(label);
              initializeUpsellDrawerOptionEvents();
            }

            async function setImageOrLabel() {
              for (const ext of formats) {
                const url1 = basePath + `${filename1Base}.${ext}`;
                const url2 = basePath + `${filename2Base}.${ext}`;

                if (await checkImageExists(url1)) {
                  img.src = url1;
                  break;
                } else if (await checkImageExists(url2)) {
                  img.src = url2;
                  break;
                }
              }

              if (!img.src) {
                replaceImgWithLabel();
              }
            }

            setImageOrLabel();

            optionsContainer.appendChild(img);
          });

          optionsWrapper.appendChild(switchDiv);
        });
      }


      //UPSELL DRAWER DESCRIPTION
      const descriptionWrapper = document.querySelector('.upsell-drawer-product-description');

      if (descriptionWrapper) {
        const linkElement = descriptionWrapper.querySelector('#see-full-product');

        if (linkElement) {
          const descEl = document.createElement('div');
          descEl.innerHTML = product.description || '';

          descriptionWrapper.insertBefore(descEl, linkElement);

          linkElement.setAttribute('href', '/products/' + product.handle);
        }
      }

      //UPSELL DRAWER BUTTON PRICE
      const priceSpan = document.querySelector('#upsell-drawer-add-to-cart span');
      if (priceSpan) {
        priceSpan.textContent = formatMoney(product.price, moneyFormat);
      }

      //UPSELL DRAWER END

      // UPSELL PRODUCT PAGE BLOCK (Original logic)
      const upsellImage = document.getElementById("upsell-image")
      if (upsellImage) {
        upsellImage.src = product.featured_image || ""
        upsellImage.alt = product.title || ""
      }
      const upsellTitle = document.getElementById("upsell-title")
      if (upsellTitle) upsellTitle.textContent = product.title || ""
      const upsellVariant = document.getElementById("upsell-variant")
      if (upsellVariant) {
        if (product.variants && product.variants.length > 0)
          upsellVariant.textContent = product.variants[0].title || "Default"
        else upsellVariant.textContent = "Default"
      }
      const upsellPrice = document.getElementById("upsell-price");
      if (upsellPrice) {
        const formattedPrice = formatMoney(product.price, moneyFormat);
        upsellPrice.innerHTML = formattedPrice;
      }
      const upsellBlock = document.getElementById("upsell-container")
      if (upsellBlock) {
        upsellBlock.style.display = "block"
        upsellBlock.style.visibility = "visible"
      }
      const addToCartBtn = document.getElementById("add-to-cart-btn")
      if (addToCartBtn) {
        if (product.variants && product.variants.length > 0) {
          const variantId = product.variants[0].id
          addToCartBtn.setAttribute("data-product-id", variantId)
          addToCartBtn.style.display = "inline-block"
        } else {
          addToCartBtn.setAttribute("data-product-id", "")
          addToCartBtn.style.display = "none"
        }
      }

      const upsellLink = document.getElementById("product-upsell-link")
      if (upsellLink && product.handle) {
        upsellLink.setAttribute("href", `/products/${product.handle}`)
      }
    }

    // Hide the upsell block
    function hideUpsellBlock() {
      if (upsellContainer) {
        upsellContainer.style.display = "none";
        upsellContainer.style.visibility = "hidden";
      }
    }


    // Fetches product recommendations from Shopify's API.
    fetch(`/recommendations/products.json?product_id=${productId}&intent=complementary&limit=1`)
      .then((res) => res.json())
      .then((data) => {
        if (data.products && data.products.length > 0) {
          displayUpsellProduct(data.products[0]);
        } else {
          hideUpsellBlock();
        }
      })
      .catch((error) => {
        console.error("Error fetching complementary products:", error);
        hideUpsellBlock();
      });
  });


})();